export default __webpack_public_path__ + "static/media/map.4672806b.svg";